/* eslint-disable import/no-duplicates */
import { format, parseISO, isSameDay } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'
import Modal from 'new-components/Modal'
import { useValidations } from 'pages/MyQueries/hooks/useValidations'
import { Consultation } from 'pages/MyQueries/types/appointment'
import { CalendarBlank } from 'phosphor-react'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { PiStethoscopeLight } from 'react-icons/pi'
import { useHistory, useLocation } from 'react-router'

import { formatReal } from 'utils/formatters'
import { redirectLink } from 'utils/redirectLink'
import When from 'utils/when'
import { EvalueteQuery, TabContentModalQueries } from '../Modals'
import { useValidateActions } from './hooks/useValidateActions'

import * as Styles from './styles'

function CardQueries({
  prescriber,
  current_status,
  amount,
  date,
  hour,
  uuid,
  id,
  event_link,
  recipe_link,
  nps,
  createdAt
}: Consultation) {
  const { professional_name, id: professional_id, include_return_visit, return_period, return_visit_value } = prescriber
  const { status_description } = current_status
  const { isWithinByHours } = useValidations()
  const history = useHistory()
  const { pathname } = useLocation()
  const isAspaecArea = pathname.toLowerCase().startsWith('/areaassociados')
  const [cancelModal, setCancelModal] = useState(false)
  const [evalueteModal, setEvalueteModal] = useState(false)
  const [tabSelect, setTabSelect] = useState<'info' | 'reschedule' | 'rescheduled'>('info')
  const consultationDateTime = parseISO(`${date}T${hour}`)
  const formattedDayOfWeek = format(consultationDateTime, 'EEEE', { locale: ptBR })
  const formattedDate = format(consultationDateTime, "dd/MM 'às' HH:mm", { locale: ptBR })
  const isFinished = isWithinByHours(date, hour, 0.3)
  const { ButtonProps, ValidateLinkActions } = useValidateActions(status_description.name, isFinished.finished, !!nps)
  const { setValue } = useFormContext()

  const isCreatedToday = createdAt && isSameDay(parseISO(createdAt), consultationDateTime)

  const resetData = () => {
    setValue('scheduling_date', null)
  }

  const handleTab = (value: 'info' | 'reschedule') => {
    setCancelModal(true)
    setTabSelect(value)
  }

  const handleReschedule = () => {
    if (isAspaecArea) {
      redirectLink(`/aspaec/agendamento?filter_by=prescriber&filter_by_id=${professional_id}`)
    } else {
      redirectLink(`/agendamento?filter_by=prescriber&filter_by_id=${professional_id}`)
    }
  }

  const handleCloseModal = () => {
    setCancelModal(false)
    resetData()
  }

  const handleActionButton = () => {
    if (isFinished.finished) {
      redirectLink(`/agendamento`)
    }
    if (status_description.name === 'waiting_payment') {
      redirectLink(`/agendamento/cart_id=${uuid}`)
    } else if (status_description.name === 'waiting_appointment') {
      redirectLink(event_link)
    } else {
      history.push('/agendamento')
    }
  }

  const formattedDateDisplay = format(consultationDateTime, 'dd/MM/yyyy', { locale: ptBR })
  const formattedDayOfWeekShort = format(consultationDateTime, 'EEEE', { locale: ptBR })
  const formattedDateFull = `${formattedDayOfWeekShort} ${formattedDateDisplay}`

  return (
    <Styles.Wrapper status={status_description.name}>
      <Styles.CardContent>
        <Styles.InfoBox className="info">
          <Styles.IconBox>
            <PiStethoscopeLight size={24} />
          </Styles.IconBox>
          <Styles.Name>{professional_name}</Styles.Name>
        </Styles.InfoBox>

        <Styles.DateInfo>{formattedDateFull}</Styles.DateInfo>

        <Styles.AppointmentInfo>Consulta online {formatReal(amount)}</Styles.AppointmentInfo>

        <Styles.ButtonActions>
          {!isCreatedToday && (
            <ValidateLinkActions
              cancelAction={() => handleTab('info')}
              rescheduleAction={isAspaecArea ? handleReschedule : () => handleReschedule()}
              evalueteAction={() => setEvalueteModal(true)}
              onMyPrescription={() => redirectLink(recipe_link || '')}
              withPrescription={!!recipe_link}
            />
          )}
        </Styles.ButtonActions>
      </Styles.CardContent>

      <Modal isOpen={cancelModal} setOpenModal={handleCloseModal} bgColor=" #f2f2f2">
        <TabContentModalQueries
          date={date}
          hour={hour}
          value={tabSelect}
          handleTab={(tab) => setTabSelect(tab)}
          prescriberInfos={prescriber}
          appointmentId={id}
          closeModal={handleCloseModal}
        />
      </Modal>

      <Modal isOpen={evalueteModal} setOpenModal={setEvalueteModal}>
        <EvalueteQuery
          nps_values={nps}
          prescriber_name={prescriber.professional_name}
          appointment_id={id}
          onClose={() => setEvalueteModal(false)}
        />
      </Modal>
    </Styles.Wrapper>
  )
}

export default CardQueries
